<template>
  <div>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Addition Code"
        v-model="editedItem.additionCode" type="text" :rules="reqdSelectValidation" />
        <v-text-field class="input-text-size" label="Description"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.description" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Tax District"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.taxDistrict" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Section"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.section" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Township"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.townShip" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Range"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.range" />
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field class="input-text-size" label="Quarter Section"
        v-model="editedItem.quarter" type="number" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxAdditionsDialog',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxAdditionsTable',
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
